export default class ProjectItemTemplates {
  spawnRules = [
    "{",
    '  format_version: "1.8.0",',
    '  "minecraft:spawn_rules": {',
    "    description: {",
    '      identifier: "custom:identifier",',
    "    },",
    "    conditions: [],",
    "  },",
    "};",
  ];
}
